// MarketingLayout.jsx
import React from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { 
  BarChart, Zap, LayoutTemplate, Users, Settings 
} from 'lucide-react';
import styles from './MarketingLayout.module.css';

const marketingNav = [
  { name: 'WA Dashboard', path: '/marketing/whatsapp', icon: BarChart },
  { name: 'Campaigns', path: '/marketing/campaigns', icon: Zap },
  { name: 'Templates', path: '/marketing/templates', icon: LayoutTemplate },
  { name: 'Audience', path: '/marketing/audience', icon: Users },
  { name: 'WA Settings', path: '/marketing/settings', icon: Settings },
];

const MarketingLayout = () => {
  const location = useLocation();

  return (
    <div className={styles.marketingWrapper}>
      <aside className={styles.subSidebar}>
        <div className={styles.subSidebarHeader}>
          <h2>Marketing Hub</h2>
          <p>WhatsApp Campaigns</p>
        </div>
        
        <nav className={styles.subNavMenu}>
          {marketingNav.map((item, idx) => {
            const IconComponent = item.icon;
            const isActive = location.pathname.includes(item.path);
            return (
              <NavLink key={idx} to={item.path} className={`${styles.subNavItem} ${isActive ? styles.active : ''}`}>
                <IconComponent size={14} strokeWidth={2.5} />
                <span>{item.name}</span>
              </NavLink>
            );
          })}
        </nav>
      </aside>

      <main className={styles.marketingContent}>
        <Outlet /> 
      </main>
    </div>
  );
};

export default MarketingLayout;